import { BaseDto } from "@/shared/dtos/base-dto";
import { provincias } from "./provincias";

export class comunidad_autonoma extends BaseDto {
  public nombre!: string;
  public provincias!:provincias[];
}
